// Inngest 媒资准备步骤通过私有 provider option 注入「源视频 URL → VOD mediaId」映射，
// 适配器创建字幕擦除任务时按 URL 取用。本文件无服务端依赖，可被客户端 bundle 安全引用。

export const BAIDU_VOD_MEDIA_IDS_OPTION = '__baiduVodMediaIds';

export function buildBaiduVodMediaLookupKey(sourceUrl: string): string {
    return sourceUrl.trim();
}

export function getBaiduVodMediaIdFromOptions(
    providerOptions: Record<string, any> | undefined,
    sourceUrl: string,
): string | undefined {
    const mediaIds = providerOptions?.[BAIDU_VOD_MEDIA_IDS_OPTION];
    if (!mediaIds || typeof mediaIds !== 'object') return undefined;
    const mediaId = mediaIds[buildBaiduVodMediaLookupKey(sourceUrl)];
    return typeof mediaId === 'string' && mediaId ? mediaId : undefined;
}
